import { useMutation } from 'react-query';

import { API_BASE_PATH } from '@/config';
import { axios } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { Data } from '@/types';

import { TTimeOff } from '../types';

export const cancelTimeOff = ({ id }: { id: number }) =>
  axios.patch(`${API_BASE_PATH}/workers/time-off/${id}`, {
    status: 'canceled',
  });

type UseCancelTimeOffOptions = {
  config?: MutationConfig<typeof cancelTimeOff>;
};

export const useCancelTimeOff = ({ config }: UseCancelTimeOffOptions = {}) => {
  return useMutation({
    onMutate: async (cancelTimeOff) => {
      await queryClient.cancelQueries('reviewed-time-off');

      const previousTimeOffs = queryClient.getQueryData<Data<TTimeOff[]>>('reviewed-time-off');

      queryClient.setQueryData(
        'reviewed-time-off',
        previousTimeOffs?.data?.filter((timeOff) => timeOff.id !== cancelTimeOff.id)
      );

      return { previousTimeOffs };
    },
    onError: (_, __, context: any) => {
      if (context?.previousTimeOffs) {
        queryClient.setQueryData('reviewed-time-off', context.previousTimeOffs);
      }
    },
    onSuccess: () => queryClient.invalidateQueries('reviewed-time-off'),
    ...config,
    mutationFn: cancelTimeOff,
  });
};
